<script setup>
import { computed,defineProps,onMounted } from "vue"

import Global from '../../js/constant.js'
// props
defineProps({
  mode: {
    type: Number,
    required: true
  },
})
// computed
const mobile = computed(() => {
  return Global.device_division_id.mobile
})
// mounted
onMounted(() => {});
</script>

<template>
  <ul :class="[ {sub : mode == mobile } ]">
    <li><router-link to = "/about-cotolike">このサイトについて</router-link></li>
    <li><router-link to = "/privacy-policy">プライバシーポリシー</router-link></li>
    <li><router-link to = "/terms-service">利用規約</router-link></li>
  </ul>
</template>
